import autoBind from 'auto-bind';
const { Component } = require("react")

export default class Abstract extends Component {

}
